import Marquee from "react-fast-marquee";
import { PawPrint } from "lucide-react";

const ITEMS = [
  "Écoute",
  "Bienveillance",
  "Apaisement",
  "Équilibre",
  "Liens familiaux",
  "Confiance",
];

export default function ValueMarquee() {
  return (
    <div data-testid="value-marquee" className="overflow-hidden border-y border-cream/10 bg-forest-deep py-6">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-10 flex items-center gap-10 md:mx-14 md:gap-14">
            <span className="marquee-item">{item}</span>
            <PawPrint size={18} className="text-sand/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
